import { render } from "./AlzataProfile.vue?vue&type=template&id=11e5f8e5"
import script from "./AlzataProfile.vue?vue&type=script&lang=js"
export * from "./AlzataProfile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__